module.exports = __webpack_public_path__ + "img/status-404.3c24b60.png";